import React from "react";

export const SpotifyIcon = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="white">
    <circle cx="12" cy="12" r="10" fill="#1DB954"/>
    <path d="M16.5 10.5c-3.5-2-9-2-9 0M16 13c-3-1.5-7.5-1.5-7.5 0M15 15.5c-2.5-1-6-1-6 0" stroke="white" strokeWidth="1.5" strokeLinecap="round" fill="none"/>
  </svg>
);

export const TriangleIcon = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="white">
    <circle cx="12" cy="12" r="10" fill="#FF6600"/>
    <path d="M12 8L8 16h8L12 8z" fill="white"/>
  </svg>
);

export const RocketIcon = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="white">
    <path d="M13.13 22.19L11.5 18.36C13.07 17.78 14.54 17 15.9 16.09L13.13 22.19ZM5.64 12.5L1.81 10.87L7.91 8.1C7 9.46 6.22 10.93 5.64 12.5ZM21.61 2.39C21.61 2.39 16.66 1.87 13 5.54C11.96 6.58 11.2 7.78 10.65 9.04L7.1 7.1L5.66 8.54L8.59 11.47L3.76 15.29L5.17 16.7L9 11.88L11.93 14.81L13.37 13.37L11.42 9.84C12.68 9.29 13.88 8.53 14.92 7.49C18.59 3.82 18.07 -1.13 18.07 -1.13C18.07 -1.13 13.12 -0.61 9.46 3.06C6.89 5.63 5.57 9.11 5.57 9.11C5.57 9.11 7.09 9.84 8.85 10.88C9.43 11.22 10.04 11.59 10.66 12L9.96 13.86C9.27 13.47 8.59 13.05 7.93 12.61C6.34 11.58 4.91 10.41 4.91 10.41C4.91 10.41 4.02 13.36 5.13 16.21C6.24 19.06 8.91 21.09 8.91 21.09C8.91 21.09 11.86 20.2 14.71 21.31C17.56 22.42 20.53 19.09 20.53 19.09C20.53 19.09 22.56 16.42 21.45 13.57C20.34 10.72 17.39 9.83 17.39 9.83C17.39 9.83 16.26 11.26 15.23 12.85C14.79 13.51 14.37 14.19 13.98 14.88L15.84 15.58C16.27 14.96 16.64 14.35 16.98 13.77C18.02 12.01 18.75 10.49 18.75 10.49C18.75 10.49 22.43 9.97 21.91 5.02C21.39 0.07 21.61 2.39 21.61 2.39Z" fill="#FF6B42"/>
  </svg>
);

export const DroneIcon = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="white">
    <path d="M14.08 12.04L12 10.71L9.92 12.04L10.47 9.65L8.5 8.05L10.96 7.88L12 5.5L13.04 7.88L15.5 8.05L13.53 9.65L14.08 12.04ZM12 15.5C9.66 15.5 7.75 13.59 7.75 11.25C7.75 8.91 9.66 7 12 7C14.34 7 16.25 8.91 16.25 11.25C16.25 13.59 14.34 15.5 12 15.5ZM12 5C8.96 5 6.5 7.46 6.5 10.5C6.5 13.54 8.96 16 12 16C15.04 16 17.5 13.54 17.5 10.5C17.5 7.46 15.04 5 12 5ZM19 10.5C19 14.64 15.64 18 11.5 18C7.36 18 4 14.64 4 10.5C4 6.36 7.36 3 11.5 3C15.64 3 19 6.36 19 10.5ZM21.5 10.5C21.5 5.26 17.24 1 12 1C6.76 1 2.5 5.26 2.5 10.5C2.5 15.74 6.76 20 12 20C17.24 20 21.5 15.74 21.5 10.5Z" fill="#FF6B42"/>
  </svg>
);

export const RefreshIcon = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="white">
    <path d="M17.65 6.35C16.2 4.9 14.21 4 12 4C7.58 4 4.01 7.58 4.01 12C4.01 16.42 7.58 20 12 20C15.73 20 18.84 17.45 19.73 14H17.65C16.83 16.33 14.61 18 12 18C8.69 18 6 15.31 6 12C6 8.69 8.69 6 12 6C13.66 6 15.14 6.69 16.22 7.78L13 11H20V4L17.65 6.35Z" fill="#FF6B42"/>
  </svg>
);

export const LightningIcon = ({ color = '#0066FF' }) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M13 2L3 14h9l-1 8 10-12h-9l1-8z"/>
  </svg>
);

export const GlobeIcon = ({ color = '#0066FF' }) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <circle cx="12" cy="12" r="10"/>
    <path d="M2 12h20M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z"/>
  </svg>
);

export const VideoCameraIcon = ({ color = '#0066FF' }) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M23 7l-7 5 7 5V7zM15 17H3V7h12v10z"/>
  </svg>
);

export const SquareIcon = ({ color = '#0066FF' }) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <rect x="3" y="3" width="18" height="18" rx="2" ry="2"/>
  </svg>
);

export const PenToolIcon = ({ color = '#0066FF' }) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M12 19l7-7 3 3-7 7-3-3z"/>
    <path d="M18 13l-1.5-7.5L2 13.5 7.5 15z"/>
    <path d="M2 2l7.5 7.5"/>
  </svg>
);

export const SettingsIcon = ({ color = '#0066FF' }) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <circle cx="12" cy="12" r="3"/>
    <path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 0 1 0 2.83 2 2 0 0 1-2.83 0l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-2 2 2 2 0 0 1-2-2v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 0 1-2.83 0 2 2 0 0 1 0-2.83l.06-.06a1.65 1.65 0 0 0 .33-1.82 1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1-2-2 2 2 0 0 1 2-2h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 0 1 0-2.83 2 2 0 0 1 2.83 0l.06.06a1.65 1.65 0 0 0 1.82.33H9v-.09A1.65 1.65 0 0 0 10.6 4.6a1.65 1.65 0 0 0 .33-1.82l-.06-.06a2 2 0 0 1 0-2.83 2 2 0 0 1 2.83 0l.06.06a1.65 1.65 0 0 0 1.82.33 1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 2 2 2 2 0 0 1-2 2h-.09A1.65 1.65 0 0 0 19.4 15z"/>
  </svg>
);

export const LinkIcon = ({ color = '#5C6BC0' }) => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M10 13a5 5 0 0 0 7.54.54l3-3a5 5 0 0 0-7.07-7.07l-1.72 1.71"/>
    <path d="M14 11a5 5 0 0 0-7.54-.54l-3 3a5 5 0 0 0 7.07 7.07l1.71-1.71"/>
  </svg>
);

export const ArrowRightIcon = ({ color = '#5C6BC0' }) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <line x1="5" y1="12" x2="19" y2="12"></line>
    <polyline points="12 5 19 12 12 19"></polyline>
  </svg>
);

export const StarIcon = ({ fill = '#FFD700' }) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill={fill} stroke="none">
    <path d="M12 17.27L18.18 21l-1.64-7.03L22 9.24l-7.19-.61L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21z"/>
  </svg>
);

export const LogoIcon = () => (
  <svg width="40" height="40" viewBox="0 0 50 50" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="25" cy="25" r="25" fill="#5C6BC0"/>
    <path d="M15 35C15 25 25 15 35 15" stroke="white" strokeWidth="4" strokeLinecap="round"/>
    <path d="M35 35C35 25 25 35 15 25" stroke="#FF6B42" strokeWidth="4" strokeLinecap="round"/>
  </svg>
);

export const QuoteIcon = ({ size = 48, color = '#373e6d' }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
    <path d="M10 20v-6a4 4 0 0 1 4-4v-4a4 4 0 0 0-4 4v6h-4a4 4 0 0 1-4-4V6a4 4 0 0 0 4 4v4h4z"/>
    <path d="M20 20v-6a4 4 0 0 1 4-4v-4a4 4 0 0 0-4 4v6h-4a4 4 0 0 1-4-4V6a4 4 0 0 0 4 4v4h4z"/>
  </svg>
);

export const WhatsAppIcon = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="white">
    <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413Z"/>
  </svg>
);
export const PlusIcon = ({ color = '#000000' }) => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M12 5V19M5 12H19" stroke={color} strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);

export const SearchIcon = ({ color = '#ffffff' }) => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="11" cy="11" r="8" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M21 21L16.65 16.65" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);